export enum EChatAppIds {
  INPUT_CONTAINER = '_INPUT_CONTAINER_', // mindos 引导定位
  FIRST_SENTENCE = '_FIRST_SENTENCE_', // mindos 引导定位
  CANVAS_POPOVER = '_CANVAS_POPOVER_', // canvas popover 的提示框
  CANVAS_QUOTE_ITEM = '_CANVAS_QUOTE_ITEM_', // canvas 引用的区域
  CANVAS_QUOTE_BUTTON = '_CANVAS_QUOTE_BUTTON_' // canvas 引用的内容
}

export enum EAppMode {
  CHAT_MODE = 'CHAT_MODE',
  CHAT_MOBILE = 'CHAT_MOBILE'
}

export const DEFAULT_APP_MODE = EAppMode.CHAT_MOBILE;
